import React, { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';

import style from './style.module.css';

import AddExecutiveContactPopup from './AddExecutiveContactPopup';
import AddLpContactPopup from './AddLpContactPopup';
import AddCompanyBuyerPopup from './AddCompanyBuyerPopup';
import AddEmailTemplatePopup from './AddEmailTemplatePopup';
import AddPositionPopup from './AddPositionPopup';
import AddCompanyContactPopup from './AddCompanyContactPopup';
import AddCompanyTargetPopup from './AddCompanyTargetPopup';
import AddFundPopup from './AddFundPopup';
import EventContactPopup from './EventContactPopup';
import ExecutiveRolePopup from './ExecutiveRolePopup';
import LPRolePopup from './LPRolePopup';
import EditAddressPopup from './EditAddressPopup';
import TemplatePopup from './TemplatePopup';
import NewIndustryPopup from './NewIndustryPopup';
import ConfirmPopup from './ConfirmPopup';
import CCVisitReportPopup from './CCVisitReportPopup';
import OutreachReportPopup from './OutreachReportPopup';
import CeoOutreachReportPopup from './CeoOutreachReportPopup';
import SetNextActionsPopup from './SetNextActionsPopup';
import ChangeStatusPopup from './ChangeStatusPopup';
import EditFiscalYearPopup from './EditFiscalYearPopup';
import AddHarvcoTagPopup from './AddHarvcoTagPopup';
import DeleteConfirmPopup from './DeleteConfirmPopup';
import InternalFlipPopup from './nextAction/InternalFlipPopup';
import PushNextActionPopup from './PushNextActionPopup';
import PushNextActionDatesPopup from './PushNextActionDatesPopup';
import ApiErrorPopup from './ApiErrorPopup';
import AddUpdateBuyerPopup from './AddUpdateBuyerPopup';
import RuntimeErrorPopup from './RuntimeErrorPopup';
import ErrorPopup from './ErrorPopup';
import EventCompanyPopup from './EventCompanyPopup';
import EditContactPopup from './EditContactPopup';
import EditPhoneContactChannelPopup from './EditPhoneContactChannelPopup';
import EditEmailContactChannelPopup from './EditEmailContactChannelPopup';
import EmailFinderPopup from './EmailFinderPopup';
import MarkMailingCompletedPopup from './MarkMailingCompletedPopup';
import MeetingDetailsPopup from './MeetingDetailsPopup';
import AddNewPlatformProject from './AddNewPlatformProject';
import AddNewCEOProject from './AddNewCEOProject';
import BuyerRolePopup from './BuyerRolePopup';
import AddBuyerCompanyPopup from './AddBuyerCompanyPopup';
import StatusCodePopup from './StatusCodePopup';
import ActiveTargetPopup from './ActiveTargetPopup';
import TagsManagementPopup from './TagsManagementPopup';
import UpdateHighStatusPopup from './UpdateHighStatusPopup';
import DescriptionChangePopup from './DescriptionChangePopup';
import RunWindwardReportPopup from './RunWindwardReportPopup';
import GenerateOnlineApprovalListPopup from './GenerateOnlineApprovalListPopup';
import ShareLinkPopup from './ShareLinkPopup';
import OneOffApproachPopup from './OneOffApproachPopup';
import AddAddonProjectPopup from './AddAddonProjectPopup';
import NdaRequestPopup from './Company/Target/NdaRequestPopup';
import UploadTemplatePopup from './UploadTemplatePopup';
import ClientSummaryReportPopup from './ClientSummaryReportPopup';
import AddTradeShowEventPopup from './AddTradeShowEventPopup';
import AssignTradeShowPopup from './AssignTradeShowPopup';
import ConflictReportPopup from './ConflictReportPopup';
import RetainerHealthPopup from './RetainerHealthPopup';
import SaveQueryPopup from './SaveQueryPopup';
import EditTagPopup from './EditTagPopup';
import UserDetailsPopup from './UserDetailsPopup';
import ProfilePopup from './ProfilePopup';
import AgreementCategoriesPopup from './AgreementCategoriesPopup';
import AgreementLinkPopup from './AgreementLinkPopup';
import DeleteRestartedAgreementPopup from './DeleteRestartedAgreementPopup';
import EmailTemplatePreviewPopup from './EmailTemplatePreviewPopup';
import { OutgoingCallPopup } from './OutgoingCallPopup';
import { AddEmailTemplateSendGridPopup } from './EmailTemplateSendGridPopup/AddEmailTemplateSendGridPopup';
import { EditEmailTemplateSendGridPopup } from './EmailTemplateSendGridPopup/EditEmailTemplateSendGridPopup';
import { TemplateEditorPopup } from './TemplateEditorPopup';
import { MailingLogPopup } from './MailingLogPopup';
import { MailingInfoSendPopup } from './MailingInfoSendPopup';
import ProjectDetailsPopup from './ProjectDetailsPopup';
import EProjectDetailsPopup from './EProjectDetailsPopup';
import AddOnProjectDetailsPopup from './AddOnProjectDetailsPopup';

/**
 * All application's popups.
 * These popups will be available to open via `this.context.openPopup('<String component name>', {<props>});`.
 *
 * @type {object}
 */
export const POPUPS = {
  ...Popups,
  AddExecutiveContactPopup,
  AddCompanyBuyerPopup,
  AddEmailTemplatePopup,
  AddLpContactPopup,
  AddPositionPopup,
  AddFundPopup,
  AddCompanyContactPopup,
  AddTradeShowEventPopup,
  AssignTradeShowPopup,
  EventContactPopup,
  CeoOutreachReportPopup,
  CCVisitReportPopup,
  OutreachReportPopup,
  ExecutiveRolePopup,
  EditFiscalYearPopup,
  AddBuyerCompanyPopup,
  AddCompanyTargetPopup,
  LPRolePopup,
  ConfirmPopup,
  EditAddressPopup,
  TemplatePopup,
  NewIndustryPopup,
  SetNextActionsPopup,
  ChangeStatusPopup,
  AddHarvcoTagPopup,
  InternalFlipPopup,
  DeleteConfirmPopup,
  PushNextActionPopup,
  PushNextActionDatesPopup,
  ApiErrorPopup,
  RuntimeErrorPopup,
  ErrorPopup,
  ClientSummaryReportPopup,
  AddUpdateBuyerPopup,
  EventCompanyPopup,
  EditPhoneContactChannelPopup,
  EditEmailContactChannelPopup,
  EmailFinderPopup,
  EditContactPopup,
  MarkMailingCompletedPopup,
  MeetingDetailsPopup,
  AddNewPlatformProject,
  AddNewCEOProject,
  StatusCodePopup,
  BuyerRolePopup,
  ActiveTargetPopup,
  TagsManagementPopup,
  UpdateHighStatusPopup,
  DescriptionChangePopup,
  RunWindwardReportPopup,
  GenerateOnlineApprovalListPopup,
  ShareLinkPopup,
  OneOffApproachPopup,
  AddAddonProjectPopup,
  NdaRequestPopup,
  UploadTemplatePopup,
  ConflictReportPopup,
  RetainerHealthPopup,
  SaveQueryPopup,
  EditTagPopup,
  UserDetailsPopup,
  ProfilePopup,
  AgreementCategoriesPopup,
  AgreementLinkPopup,
  DeleteRestartedAgreementPopup,
  EmailTemplatePreviewPopup,
  OutgoingCallPopup,
  AddEmailTemplateSendGridPopup,
  EditEmailTemplateSendGridPopup,
  TemplateEditorPopup,
  MailingLogPopup,
  MailingInfoSendPopup,
  ProjectDetailsPopup,
  EProjectDetailsPopup,
  AddOnProjectDetailsPopup,
};

const EXIT_DURATION = 195;

/**
 * Popup wrapper to display backdrop and popup itself if need.
 *
 * @param props {Object}.
 * @param props.popup {Immutable.Map} Popup's meta info (props, name).
 */
const PopupContainer = ({ popup }) => {
  const isOpen = hasPopupWithName(popup.get('name'));
  const [displayedPopup, setDisplayedPopup] = useState(popup);
  const [isExiting, setIsExiting] = useState(false);

  if (isOpen && displayedPopup !== popup) {
    setDisplayedPopup(popup);
  }

  if (isOpen && isExiting) {
    setIsExiting(false);
  }

  if (!isOpen && !isExiting && hasPopupWithName(displayedPopup.get('name'))) {
    setIsExiting(true);
  }

  useEffect(() => {
    if (!isExiting) return undefined;

    const timer = setTimeout(() => {
      setDisplayedPopup(popup);
      setIsExiting(false);
    }, EXIT_DURATION);

    return () => clearTimeout(timer);
  }, [isExiting, popup]);

  const backdrop = getBackdrop({ popup: displayedPopup, isExiting });
  const popupContent = getPopupContent({ popup: displayedPopup });

  return (
    <>
      {backdrop}
      {popupContent}
    </>
  );
};

function mapStateToProps(state, props) {
  return props;
}

export { PopupContainer };
export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(PopupContainer));

/**
 * Check if a popup with this name exists.
 *
 * @param name {String}.
 */
function hasPopupWithName(name) {
  return Object.prototype.hasOwnProperty.call(POPUPS, name);
}

/**
 * Returns Popup content is application has popup with such name.
 *
 * @param popup {Immutable.Map} Popup's meta info (props, name).
 */
function getPopupContent({ popup }) {
  const name = popup.get('name');

  if (!hasPopupWithName(name)) {
    if (name !== null) {
      console.error(`No Popup with name "${name}". Display empty <div/>`);
    }

    return <div />;
  }

  const PopupContent = POPUPS[name];

  return <PopupContent popup={popup} />;
}

/**
 * Returns Popup's backdrop. If no such popup - do not display anything (fade has opacity=0).
 *
 * @param popup {Immutable.Map} Popup's meta info (props, name).
 * @param isExiting {Boolean} Popup is playing its close animation.
 */
function getBackdrop({ popup, isExiting }) {
  const name = popup.get('name');

  let className = 'fade';

  if (hasPopupWithName(name)) {
    className = classNames('modal-backdrop fade in', isExiting ? style.exit : style.enter, {
      unclosable: POPUPS[name].closable === false,
    });
  }

  return <div className={className} />;
}
